import type { Experience, PurchaseOption } from '../../../../../types/CoreShoppingExperience';

export const hasContinuousPricingFromExperience = (experience: Experience | undefined) => {
  if (!experience) {
    return false;
  }
  const flattenSteps = experience?.purchasableTrips.flatMap((purchasableTrip) => purchasableTrip?.steps);
  const flattenProducts = flattenSteps?.flatMap((step) => step?.products);
  const flattenVariants = flattenProducts?.flatMap((product) => product?.variants);
  const flattenPurchasableOptions = flattenVariants?.flatMap((variant) => variant?.purchaseOptions);
  const uniquesEntries = new Set(
    flattenPurchasableOptions?.map((purchasableOption) => !!purchasableOption.settings.continuousPricing),
  );
  return uniquesEntries.has(true);
};

export const hasContinuousPricingFromPurchaseOption = (purchaseOption?: PurchaseOption) =>
  Boolean(purchaseOption?.settings.continuousPricing);
